import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Flights from "@/pages/Flights";
import Hotels from "@/pages/Hotels";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Offers from "@/pages/Offers";
import Dashboard from "@/pages/Dashboard";
import Auth from "@/pages/Auth";
import Voucher from "@/pages/Voucher";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import Tips from "@/pages/Tips";
import TipDetail from "@/pages/TipDetail";
import "@/App.css";

function Shell() {
  const loc = useLocation();
  const bare = loc.pathname === "/auth";
  return (
    <div className="flex flex-col min-h-screen">
      {!bare && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/flights" element={<Flights />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:id" element={<PackageDetail />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tips" element={<Tips />} />
          <Route path="/tips/:id" element={<TipDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/booking/:ref" element={<Voucher />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <WhatsAppFloat />}
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Shell />
      </BrowserRouter>
    </AppProvider>
  );
}
